<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="860px"
    append-to-body
    @close="close"
  >
    <div class="history-toolbar">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="openForm()"
        >{{ addText }}</el-button
      >
    </div>
    <el-table v-loading="loading" :data="rows" border stripe max-height="440">
      <el-table-column v-if="mode === 'status'" label="状态" width="100"
        ><template slot-scope="scope">{{
          Number(scope.row.status) === 16 ? "正常" : "异常"
        }}</template></el-table-column
      >
      <el-table-column
        prop="record_date"
        label="日期"
        width="170"
        :formatter="dateFormatter"
      />
      <el-table-column v-if="mode === 'progress'" label="进度" width="150"
        ><template slot-scope="scope">{{
          progressMap[scope.row.case_progress] || "-"
        }}</template></el-table-column
      >
      <el-table-column
        v-if="mode === 'progress'"
        prop="action_name"
        label="操作名称"
        width="140"
      />
      <el-table-column
        v-if="mode === 'status'"
        prop="reason"
        label="原因"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column
        v-if="mode === 'progress'"
        prop="note"
        label="备注"
        min-width="200"
        show-overflow-tooltip
      />
      <el-table-column
        v-if="mode === 'audit'"
        prop="content"
        label="内容"
        min-width="260"
        show-overflow-tooltip
      />
      <el-table-column
        prop="created_at"
        label="创建时间"
        width="170"
        :formatter="dateTimeFormatter"
      />
      <el-table-column label="操作" width="130" align="center">
        <template slot-scope="scope"
          ><el-button
            v-if="mode !== 'progress' || Number(scope.row.case_progress) > 1"
            type="text"
            @click="openForm(scope.row)"
            >编辑</el-button
          ><el-button
            v-if="mode === 'audit'"
            type="text"
            class="danger"
            @click="remove(scope.row)"
            >删除</el-button
          ></template
        >
      </el-table-column>
    </el-table>
    <el-dialog
      :title="form.id ? `编辑${recordName}` : addText"
      :visible.sync="formVisible"
      width="500px"
      append-to-body
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item v-if="mode === 'status'" label="状态" prop="status"
          ><el-select v-model="form.status"
            ><el-option label="正常" :value="16"/><el-option
              label="异常"
              :value="2"/></el-select
        ></el-form-item>
        <el-form-item
          v-if="mode === 'progress'"
          label="案件进度"
          prop="case_progress"
          ><el-select v-model="form.case_progress"
            ><el-option
              v-for="(label, value) in editableProgress"
              :key="value"
              :label="label"
              :value="Number(value)"/></el-select
        ></el-form-item>
        <el-form-item label="日期" prop="record_date"
          ><el-date-picker
            v-model="form.record_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
        /></el-form-item>
        <el-form-item v-if="mode === 'status'" label="原因"
          ><el-input
            v-model="form.reason"
            type="textarea"
            :rows="4"
            maxlength="512"
            show-word-limit
        /></el-form-item>
        <el-form-item v-if="mode === 'progress'" label="备注"
          ><el-input
            v-model="form.note"
            type="textarea"
            :rows="4"
            maxlength="512"
            show-word-limit
        /></el-form-item>
        <el-form-item v-if="mode === 'audit'" label="内容" prop="content"
          ><el-input
            v-model="form.content"
            type="textarea"
            :rows="4"
            maxlength="512"
            show-word-limit
        /></el-form-item>
      </el-form>
      <span slot="footer"
        ><el-button @click="formVisible = false">取消</el-button
        ><el-button type="primary" :loading="saving" @click="save"
          >保存</el-button
        ></span
      >
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  getStatusRecords,
  getStatusRecordInfo,
  saveStatusRecord,
  getProgressRecords,
  getProgressRecordInfo,
  saveProgressRecord,
  getAuditRecords,
  getAuditRecordInfo,
  saveAuditRecord,
  deleteAuditRecord
} from "@/api/claims-management";
import {
  CASE_PROGRESS,
  formatDate,
  formatDateTime,
  toTimestamp
} from "../constants";

export default {
  name: "RecordHistoryDialog",
  props: {
    visible: Boolean,
    orderId: [String, Number],
    mode: { type: String, required: true }
  },
  data() {
    return {
      loading: false,
      saving: false,
      rows: [],
      formVisible: false,
      progressMap: CASE_PROGRESS,
      editableProgress: {
        2: "初次提交资料",
        4: "审核通过",
        8: "保险公司定损",
        16: "签订赔偿协议",
        32: "支付赔款"
      },
      form: {},
      rules: {
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        case_progress: [
          { required: true, message: "请选择案件进度", trigger: "change" }
        ],
        record_date: [
          { required: true, message: "请选择日期", trigger: "change" }
        ],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }]
      }
    };
  },
  computed: {
    title() {
      return { status: "异常登记", progress: "进度变更", audit: "审核记录" }[
        this.mode
      ];
    },
    recordName() {
      return { status: "状态", progress: "进度", audit: "审核记录" }[this.mode];
    },
    addText() {
      return { status: "登记状态", progress: "变更进度", audit: "添加记录" }[
        this.mode
      ];
    }
  },
  watch: {
    visible(value) {
      if (value) this.fetchList();
    }
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const fn = {
          status: getStatusRecords,
          progress: getProgressRecords,
          audit: getAuditRecords
        }[this.mode];
        const res = await fn({
          order_id: Number(this.orderId),
          page: 1,
          rows: 1000
        });
        this.rows = res.rows || [];
      } finally {
        this.loading = false;
      }
    },
    async openForm(row) {
      this.form = {
        id: null,
        status: 16,
        case_progress: 2,
        record_date: formatDate(new Date()),
        reason: "",
        note: "",
        content: ""
      };
      if (row) {
        const fn = {
          status: getStatusRecordInfo,
          progress: getProgressRecordInfo,
          audit: getAuditRecordInfo
        }[this.mode];
        const res = await fn({ id: row.id });
        const info = res.data || row;
        this.form = {
          ...this.form,
          ...info,
          record_date: formatDate(info.record_date)
        };
        if (this.mode === "status")
          this.form.reason = info.reason || info.case_reason || "";
      }
      this.formVisible = true;
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const data = {
            order_id: Number(this.orderId),
            record_date: toTimestamp(this.form.record_date)
          };
          if (this.form.id) data.id = Number(this.form.id);
          if (this.mode === "status") {
            data.case_status = Number(this.form.status);
            data.case_reason = this.form.reason || "";
          }
          if (this.mode === "progress") {
            data.case_progress = Number(this.form.case_progress);
            data.note = this.form.note || "";
          }
          if (this.mode === "audit") data.content = this.form.content;
          await {
            status: saveStatusRecord,
            progress: saveProgressRecord,
            audit: saveAuditRecord
          }[this.mode](data);
          this.$message.success("保存成功");
          this.formVisible = false;
          this.fetchList();
          this.$emit("changed");
        } finally {
          this.saving = false;
        }
      });
    },
    remove(row) {
      this.$confirm("确认删除该审核记录吗？", "提示", { type: "warning" })
        .then(async () => {
          await deleteAuditRecord({ id: Number(row.id) });
          this.$message.success("删除成功");
          this.fetchList();
        })
        .catch(() => {});
    },
    close() {
      this.$emit("update:visible", false);
    },
    dateFormatter(row, column, value) {
      return formatDate(value);
    },
    dateTimeFormatter(row, column, value) {
      return formatDateTime(value);
    }
  }
};
</script>

<style scoped>
.history-toolbar {
  margin-bottom: 12px;
  text-align: right;
}
.danger {
  color: #f56c6c;
}
</style>
